module.exports = __webpack_public_path__ + "media/images/pic/teachers/kaede-funakoshi-2684ce6684572fdcf5a4b89f4a639ced.png";